import { PopupClickContainerStateless } from "@similarweb/ui-components";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import { DEFAULT_TOOLTIP_CONFIG } from "./const";
import { StyledText } from "./styles";

const APPEND_TO_SELECTOR = "body";

type ClickContainerProps = ComponentPropsWithoutRef<typeof PopupClickContainerStateless>;

type PopupProps = Pick<ClickContainerProps, "isOpen" | "onOpen" | "onClose"> & {
    isEnabled: boolean;
};

const SuggestionsNotificationTooltip = ({ children, isEnabled, ...popupProps }: PropsWithChildren<PopupProps>) => {
    const config = { ...DEFAULT_TOOLTIP_CONFIG, enabled: isEnabled };

    const renderContent = () => (
        <I18n
            translatable={{ key: "si.column-suggestions.notification.text" }}
            element={StyledText}
        />
    );

    return (
        <PopupClickContainerStateless
            {...popupProps}
            appendTo={APPEND_TO_SELECTOR}
            config={config}
            content={renderContent}
        >
            <div>{children}</div>
        </PopupClickContainerStateless>
    );
};

export default SuggestionsNotificationTooltip;
